"use client";
import Form from "next/form";
import { useEffect, useRef } from "react";
export default function Filters({
  page,
  type,
  genre,
  query,
}: {
  page: number;
  type: string;
  genre: string | null;
  query: string;
}) {
  const ref = useRef<HTMLFormElement>(null);
  const autoSubmit = () => ref.current?.requestSubmit();
  useEffect(() => {
  
    ref.current?.requestSubmit();
  }, [page, type, genre, query]);
  return (
    <Form
      ref={ref}
      replace
      scroll={false}
      action="/collection"
      className="hidden"
    >
      <input type="hidden" name="page" value={page} />
      <input type="hidden" name="type" value={type} />
      <input type="hidden" name="genre" value={genre ?? ""} />
      <input type="hidden" name="query" value={query} />
      <button type="submit" hidden />
    </Form>
  );
}
